var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 35.995,
    viewBox: "0 0 36 35.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-upload",
    "data-name": "Icon awesome-upload",
    d: "M20.813,27H15.188A1.683,1.683,0,0,1,13.5,25.313V13.5H7.334a1.4,1.4,0,0,1-.991-2.4L17.037.4a1.362,1.362,0,0,1,1.92,0l10.7,10.7a1.4,1.4,0,0,1-.991,2.4H22.5V25.313A1.683,1.683,0,0,1,20.813,27ZM36,26.438v7.875A1.683,1.683,0,0,1,34.313,36H1.688A1.683,1.683,0,0,1,0,34.313V26.438A1.683,1.683,0,0,1,1.688,24.75H11.25v.563a3.94,3.94,0,0,0,3.938,3.938h5.625a3.94,3.94,0,0,0,3.938-3.937V24.75h9.563A1.683,1.683,0,0,1,36,26.438Zm-8.719,6.188a1.406,1.406,0,1,0-1.406,1.406A1.41,1.41,0,0,0,27.281,32.625Zm4.5,0a1.406,1.406,0,1,0-1.406,1.406A1.41,1.41,0,0,0,31.781,32.625Z",
    transform: "translate(0 -0.005)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload2);
export default __webpack_public_path__ + "static/media/upload2.76334b929292b75444864e5ad77bb243.svg";
export { ForwardRef as ReactComponent };